import { render, staticRenderFns } from "./infoMiniBox.vue?vue&type=template&id=79a46273&"
import script from "./infoMiniBox.vue?vue&type=script&lang=js&"
export * from "./infoMiniBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports